import { deleteLatestLocation } from './cookies-localstorage';

export function singleServiceSearchRefresh() {
    let link = document.querySelector('.service-search-sidebar-refresh');
    if( link ) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            // Delete the latest location
            deleteLatestLocation();
            
            window.location.replace(this.href);
        })
    }
}



// WEBPACK FOOTER //
// ./src/js/single-service-intro.js